import { SearchQueryKeysMap } from '@telialt/core-search/src/model';
import { TeliaSegment } from '@telialt/utils/src/segment';

export const getDefaultProductsQueryKey = (segment: TeliaSegment, queryKeys?: SearchQueryKeysMap) => {
    if (segment === TeliaSegment.B2b) {
        return queryKeys?.['b2b-products'];
    }

    if (segment === TeliaSegment.B2c) {
        return queryKeys?.['b2c-products'];
    }

    return undefined;
};
